import { render, staticRenderFns } from "./PdpBadges.vue?vue&type=template&id=00185349&scoped=true&"
import script from "./PdpBadges.vue?vue&type=script&lang=js&"
export * from "./PdpBadges.vue?vue&type=script&lang=js&"
import style0 from "./PdpBadges.vue?vue&type=style&index=0&id=00185349&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00185349",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-badges%2FPdpBadges.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports